import { Modal } from 'antd';
import { useState } from 'react';
import { TeambinderApiService } from '@src/api';

interface FreeTrialModalProps {
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
}

const FreeTrialModal = ({ open, onCancel, onOk }: FreeTrialModalProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleStartTrial = async () => {
    try {
      setIsLoading(true);

      await TeambinderApiService.changeSubscription({
        requestBody: {
          subscriptionPlan: 'ENTERPRISE_TRIAL',
          billingCycle: 'TRIAL',
        },
      });

      setShowSuccessModal(true);
      onOk();
    } catch (error) {
      console.error('무료 체험 시작 실패:', error);
      // TODO: 에러 처리
    } finally {
      setIsLoading(false);
    }
  };

  const handleSuccessModalOk = () => {
    setShowSuccessModal(false);
    // 3. 페이지 새로고침
    window.location.reload();
  };

  return (
    <>
      <Modal
        title={null}
        open={open}
        onCancel={onCancel}
        onOk={handleStartTrial}
        okText="확인"
        cancelText="취소"
        okButtonProps={{
          style: {
            backgroundColor: '#4403B5',
            borderColor: '#4403B5',
          },
          loading: isLoading,
        }}
        width={416}
        centered
        closable={false}
      >
        <div
          style={{
            paddingTop: '8px',
            paddingBottom: '16px',
            fontSize: '18px',
            color: 'rgba(0, 0, 0, 0.85)',
          }}
        >
          엔터프라이즈 무료 한달 체험을 시작하시겠습니까?
        </div>
      </Modal>

      {/* 성공 모달 */}
      <Modal
        title={null}
        open={showSuccessModal}
        onOk={handleSuccessModalOk}
        okText="확인"
        okButtonProps={{
          style: {
            backgroundColor: '#4403B5',
            borderColor: '#4403B5',
          },
        }}
        cancelButtonProps={{
          style: {
            display: 'none',
          },
        }}
        width={416}
        centered
        closable={false}
      >
        <div
          style={{
            paddingTop: '8px',
            paddingBottom: '16px',
            fontSize: '18px',
            color: 'rgba(0, 0, 0, 0.85)',
            textAlign: 'center',
          }}
        >
          무료 체험이 시작되었습니다.
        </div>
      </Modal>
    </>
  );
};

export default FreeTrialModal;
